module.exports = __webpack_public_path__ + "assets/issemym-alt.16005c75.svg";